import './CognosDemo.scss';
import NavHeader from './NavHeader/NavHeader';
import { MemoryRouter, Route, Switch } from 'react-router-dom';
import MainPage from './MainPage/MainPage';
import { useBPName } from '../../../common/hooks/widgets/useBPName';
import { UT30CognosDemo } from '../constants/spread';
import BusinessPartner from 'src/common/components/BusinessPartner/BusinessPartner';
import { swapCountryAndLanguage } from 'src/common/utils/swapCountryAndLanguage';
import { IBMLocale } from 'src/common/locale/mapValidLocale';

export interface CognosDemoProps {
  langCode: string;
  test: boolean;
  countryToTest: string;
}

function CognosDemo({ langCode, test, countryToTest }: CognosDemoProps) {
  const { bpName, logo, companyId, desc, mssp, params } = useBPName(
    UT30CognosDemo,
    true,
  );
  const localeCode = swapCountryAndLanguage(langCode as IBMLocale);
  return (
    <MemoryRouter initialEntries={['/', '/component1']}>
      <div className="CognosDemo widget-styles">
        <NavHeader
          bpName={bpName}
          logo={logo}
          companyId={companyId}
          desc={desc}
          mssp={mssp}
          params={params}
        />
        {bpName ? (
          <>
            {' '}
            <div className="bx--grid">
              <div className="bx--row">
                <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
                  <BusinessPartner bpName={bpName} logo={logo} desc={desc} />
                </div>
              </div>
            </div>
          </>
        ) : null}
        <Switch>
          <Route exact path="/">
            <MainPage
              langCode={localeCode}
              test={test}
              countryToTest={countryToTest}
              bpName={bpName}
            />
          </Route>
        </Switch>
      </div>
    </MemoryRouter>
  );
}

export default CognosDemo;
